<template>
    <div class="vh-100">
        <nav class="bg-white sticky-top d-flex flex-column align-items-start nav navbar border-bottom ">
            <div  class="pl-5 col-sm-12 col-lg-9 d-flex align-items-end gap-3">
                <a href="https://ecorrecao.com.br/">

                    <svg class="" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 35.378 39.315">
                        <g id="Grupo_69" data-name="Grupo 69" transform="translate(-481.81 380)">
                            <g id="Grupo_68" data-name="Grupo 68" transform="translate(481.81 -380)">
                                <rect id="Retângulo_39" data-name="Retângulo 39" width="5.56" height="22.238"
                                        transform="translate(31.447 19.656) rotate(45)" fill="#00dbf9"></rect>
                                <path id="Caminho_94" data-name="Caminho 94"
                                        d="M509.329-372.137l-3.931-3.931L501.466-380l-3.931,3.931-3.931,3.931-3.931,3.931-3.931,3.931-3.931,3.931,3.931,3.931,7.863,7.863,3.931-3.931,3.931-3.931,3.931-3.931,3.931-3.931,3.931-3.931Zm-11.794,11.794-3.931,3.931-3.931-3.931,3.931-3.931,3.931-3.931,3.931-3.931,3.931,3.931Z"
                                        transform="translate(-481.81 380)" fill="#3839e3"></path>
                                <rect id="Retângulo_40" data-name="Retângulo 40" width="5.56" height="11.119"
                                        transform="translate(11.792 31.453) rotate(-45)" fill="#0195ff"></rect>
                            </g>
                        </g>
                    </svg>
                </a>
                <p class="h4 text-dark ml-2"><strong>Onboarding</strong></p>
            </div>
        </nav>
        <div class="d-flex gap-2 w-100" style="background-color: #EEEFFF;">
            <div class="bg-primary" :style="'width:'+(actualStep+1)*100/pages.length + '%;'" style="height: 0.25rem;" ></div>
        </div>
        <div class="container-fluid d-flex bg-white">
            <div class="h-100 d-flex flex-grow-1 col-lg-6">

                <div class="mx-auto d-flex flex-column justify-content-between my-auto col-sm-12 col-lg-9">
                    <div class="mt-5">
                        <p>
                            <small class="text-primary h6">
                                Passo {{ actualStep + 1 }} de {{ pages.length }}
                            </small>
                        </p>
                        <div class="d-flex gap-2 ">
                            <div style="width: 2rem; height: 0.25rem;" :style="index === actualStep ? '' :'background-color: #EEEFFF;'" class="mr-1 rounded" :class="index === actualStep ? 'bg-primary' : ''" v-for="(page, index) in pages" :key="index"></div>
                        </div>
                    </div>
                    <transition name="stepdiv">

                        <div :id="actualStep"  class="mt-5 fade-el">


                            <p class="h2 w-100 d-block fade-el">
                                <strong>
                                    {{pages[actualStep].title}}
                                </strong>
                            </p>
                            <p class="text-dark fade-el">
                                {{ pages[actualStep].subtitle }}
                            </p>

                            <iframe class="w-100 mh-50 fade-el" height="315" v-if="pages[actualStep].video_url" :src="pages[actualStep].video_url" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>


                        </div>
                    </transition>


                    <!-- Mobile -->
                    <div class="w-full mb-2 mt-5 d-block d-sm-none">
                        <button class="btn btn-primary btn-block mt-2 rounded-pill px-5 py-2" @click="onClickNext" :disabled="pages[actualStep].disabled">
                            <strong>
                                {{ pages[actualStep].btn }}
                            </strong>
                        </button>
                        <button class="btn btn-outline-primary btn-block rounded-pill px-5 py-2 mr-2" @click="onClickPrevious" v-if="actualStep !== 0">
                            <strong>
                                Voltar
                            </strong>
                        </button>
                    </div>

                    <!-- Desktop -->
                    <div class="w-full mb-2 mt-5 d-none d-sm-block">
                        <button class="btn btn-outline-primary rounded-pill px-5 py-2 mr-2" @click="onClickPrevious" v-if="actualStep !== 0">
                            <strong>
                                Voltar
                            </strong>
                        </button>
                        <button class="btn btn-primary rounded-pill px-5 py-2" @click="onClickNext" :disabled="pages[actualStep].disabled">
                            <strong>
                                {{ pages[actualStep].btn }}
                            </strong>
                        </button>
                    </div>

                </div>
            </div>
            <div class="side-image d-none d-sm-none d-md-none d-lg-flex p-2 col justify-content-end w-100">
                <img class=" mx-auto object-fit-scale min-w-50 image-size" :src="pages[actualStep].img_path" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['endpointLogin'],
    data(){
        return {
            actualStep: 0,
            pages: [
                {
                    step : 0,
                    title : 'Sua conta está quase pronta, mas antes veja como você pode começar a utilizar nossos serviços',
                    subtitle: 'Assista o vídeo abaixo para conhecer mais sobre a plataforma.',
                    btn: 'Iniciar',
                    disabled: false,
                    video_url: 'https://www.youtube.com/embed/SNXBBZeQnTw?si=NFrcSsg320O72KSL',
                    img_path: '/img/onboarding1.png'
                },
                {
                    step : 1,
                    title : 'Crie sua primeira turma na página de turmas, ao clicar no botão adicionar, preencha os dados solicitados',
                    subtitle: 'Preencha corretamente os campos solicitados, essas informações são importantes!',
                    btn: 'Próximo',
                    disabled: false,
                    video_url: 'https://www.youtube.com/embed/nGfLKLydmqM?si=mts3iT80bhJQPKDj',
                    img_path: '/img/onboarding2.png'
                },
                {
                    step : 2,
                    title : 'Adicione seu primeiro aluno clicando no botão adicionar e vincule o mesmo a turma',
                    subtitle: 'Preencha corretamente os campos solicitados, essas informações são importantes!',
                    btn: 'Próximo',
                    disabled: false,
                    video_url: 'https://www.youtube.com/embed/JopPXNU5emQ?si=wMjLQlnqQaW8G0vF',
                    img_path: '/img/onboarding3.png'
                },
                {
                    step : 3,
                    title : 'Adicione seu primeiro tema como na página abaixo',
                    subtitle: 'Preencha corretamente os campos solicitados, essas informações são importantes!',
                    btn: 'Próximo',
                    disabled: false,
                    video_url: 'https://www.youtube.com/embed/7HQ-pon2Yvs?si=m_4DOqTbupwykXyo',
                    img_path: '/img/onboarding4.png'
                },
                {
                    step : 4,
                    title : 'Na página de configurações, você pode personalizar algumas informações',
                    subtitle: 'Preencha corretamente os campos solicitados, essas informações são importantes!',
                    btn: 'Próximo',
                    disabled: false,
                    video_url: 'https://www.youtube.com/embed/wKbWCpCQWo8?si=sDIqZNtG1R_F7fru',
                    img_path: '/img/onboarding5.png'
                },
                {
                    step : 5,
                    title : 'Agora você já sabe que podemos ajudar! Vamos melhorar ainda mais para que você continue crescendo',
                    subtitle: 'Qualquer dúvida é só chamar no nosso atendimento!',
                    btn: 'Acessar sua conta',
                    disabled: false,
                    video_url: '',
                    img_path: '/img/onboarding6.png'
                },
            ],
        }
    },
    created(){
        window.localStorage.setItem('first-login', true);
    },
    methods: {
        onClickNext() {

            if ( this.actualStep <  (this.pages.length-1)) {
                this.actualStep += 1;
            } else {
                if(this.actualStep === this.pages.length-1){
                    window.location.replace(this.endpointLogin);
                }
            }
        },

        onClickPrevious() {
            this.actualStep -= 1;
        },
    }
}
</script>

<style scoped>
    .image-size{
        max-width: 600px;
        width: 100%;
    }
    .auto-height{
        height: 100%;
        max-height: 100vh;
    }


    .stepdiv-enter-active .fade-el,
    .sstepdiv-leave-active .fade-el {
        animation: fadeIn 2s ease;
    }
    .stepdiv-enter-from .fade-el,
    .stepdiv-leave-to .fade-el{
        opacity: 0;

    }
    @keyframes fadeIn {
        from {
            opacity:0;
        }

        to {
            opacity:1;
        }
     }

</style>
